export default "__VITE_ASSET__CJ41svTa__"